import { ScrollArea } from "../../ui/scroll-area";

const NotesContent = ({ noteContent }: { noteContent: string }) => (
    <ScrollArea className="pr-4" viewportClassName="max-h-30">
        {noteContent}
    </ScrollArea>
);

export default NotesContent;
